// AB module: PDF workspace / detail view expansion ("UI parity" wave, Agent FE-2).
// Key prefix stays 'abPdf.' (own file next to ab.en.js, s. BAUPLAN-AB-UI-PARITAET).
const abPdf = {
  // ---- PDF viewer (toolbar/states) ----
  'abPdf.zoomOut': 'Zoom out',
  'abPdf.zoomIn': 'Zoom in',
  'abPdf.zoomReset': 'Reset',
  'abPdf.findingsToggle': 'Matches',
  'abPdf.findingsHint': 'Marks in the PDF where the table values were found. Click a field on the right to highlight its match.',
  'abPdf.pdfLoading': 'Loading PDF…',
  'abPdf.pdfLoadError': 'PDF could not be loaded',
  'abPdf.pdfRetry': 'Retry',
  'abPdf.pdfEmpty': 'No PDF available',

  // ---- Click-to-fill mode ----
  'abPdf.pickHintIdle': 'Tip: click a field, then click the matching text in the PDF on the left — the value will be adopted.',
  'abPdf.pickHintActive': 'Active: Pos {line} · {field} — now click the value in the PDF on the left (first click replaces, further clicks append). Esc cancels.',

  // ---- Supersede banner ----
  'abPdf.supersedeTitle': 'Newer order confirmation available',
  'abPdf.supersedeMsg': 'A newer order confirmation has arrived for this purchase order ({fileName}, {date}). Only the most recent confirmation should be transferred to SAP — older ones are outdated.',
  'abPdf.supersedeOpen': 'Open latest confirmation',

  // ---- Compare/HTN panel ----
  'abPdf.compareLoading': 'Comparing with open SAP purchase orders…',
  'abPdf.compareUnavailableTitle': 'Order comparison unavailable',
  'abPdf.compareUnavailableMsg': 'Comparing with the SAP purchase order is currently not possible (e.g. timeout). The fields can still be reviewed and transferred; the comparison will retry the next time you open this document.',
  'abPdf.compareNoneFoundTitle': 'No open SAP purchase order found',
  'abPdf.compareNoneFoundMsg': 'No open SAP purchase order was found for these positions (order no. {orders}) — likely not present in this SAP environment. The fields can still be reviewed.',
  'abPdf.compareCheckedTitle': 'Checked against open SAP purchase orders',
  'abPdf.compareCheckedMsg': '{matched} of {total} position(s) matched',
  'abPdf.compareDiffSuffix': ', {n} discrepancy(ies)',
  'abPdf.compareNotFoundSuffix': ', {n} without purchase order',
  'abPdf.htnCheckButton': 'Check HTN',
  'abPdf.htnChecking': 'Checking HTN…',
  'abPdf.htnResultTitle': 'HTN check (AMPL approval list)',
  'abPdf.htnResultOkClean': 'All manufacturer part numbers checked — all good.',
  'abPdf.htnResultOkWithMissing': 'All manufacturer part numbers checked, {n} without HTN.',
  'abPdf.htnResultProblemBase': '{mismatch} position(s) with a non-approved HTN',
  'abPdf.htnResultProblemMissingSuffix': ', {missing} without HTN',
  'abPdf.htnMatch': 'HTN ✓',
  'abPdf.htnMatchTooltip': 'Approved manufacturer part no. (AMPL)',
  'abPdf.htnMismatch': 'HTN ≠',
  'abPdf.htnMismatchTooltip': 'Not approved — valid per AMPL: {valid}',
  'abPdf.htnMissing': 'HTN ?',
  'abPdf.htnMissingTooltip': 'No HTN extracted — valid per AMPL: {valid}',
  'abPdf.poAdoptTooltip': 'Adopt from purchase order: {value}',

  // ---- Missing-fields panel ----
  'abPdf.missingFieldsTitle': 'Please review / fill in manually',
  'abPdf.missingFieldsMsg': 'The following fields are empty in at least one position and could not be assigned automatically: {fields}. Enter the values directly in the table (fields highlighted in yellow) before transferring to SAP.',

  // ---- Delivery-schedule column ----
  'abPdf.einteilungLabel': 'Schedule',
  'abPdf.einteilungHint': 'Delivery schedule per purchase order position — freely editable (not an SAP field, used for the quantity comparison)',
  'abPdf.eeindPoHint': 'PO: {date}',

  // ---- Email context ----
  'abPdf.emailContextTitle': 'Email context',
  'abPdf.emailSubjectLabel': 'Subject',
  'abPdf.emailBodyEmpty': 'No email text stored.',
  'abPdf.emailOpenMailButton': 'Open email message',

  // ---- Sibling switcher (attachments of the same email) ----
  'abPdf.attachmentOf': 'Attachment {n} of {total}',
  'abPdf.attachmentPrev': 'Previous attachment',
  'abPdf.attachmentNext': 'Next attachment',

  // ---- Report workflow ----
  'abPdf.reportButton': 'Report',
  'abPdf.reportedBadge': '✓ Reported',
  'abPdf.reportAlreadyReported': 'Document has already been reported — waiting for release by an administrator.',
  'abPdf.reportResolveButton': 'Resolve report',
  'abPdf.reportDialogTitle': 'Report document',
  'abPdf.reportDialogMsg': 'Briefly describe the mapping issue. An administrator will review the document; a comment is required.',
  'abPdf.reportResolveDialogTitle': 'Resolve report',
  'abPdf.reportResolveDialogMsg': 'Leave a comment about the release. The document will be released. A comment is required.',
  'abPdf.reportCommentPlaceholder': 'Comment…',
  'abPdf.reportCommentRequired': 'Please enter a comment',
  'abPdf.reportSubmittedMsg': 'Document reported',
  'abPdf.reportResolvedMsg': 'Report resolved',
  'abPdf.reportHistoryTitle': 'Report history',
  'abPdf.reportHistoryReported': 'reported',
  'abPdf.reportHistoryResolved': 'resolved',

  // ---- Raw text / field mapping ----
  'abPdf.rawTextTitle': 'Show recognized raw text',
  'abPdf.mappingButton': 'PDF & field mapping',
};

export default abPdf;
